
export class Tile {
  #idx = null; // Tile ID
  #color = "black";
  #imgUrl = ""; // Image URL
  #permalink = "";
  #img = new Image(); // Image object
  #pathData
  #offsetX = 0; // X offset for tile position from center of canvas
  #offsetY = 0; // Y offset for tile position from center of canvas
  #elm = null;
  #wiggleDiv = null;
  #fadeDelay = 0;
  #reqAnimId = null;
  #loadPromise; // Promise that resolves when the image loads
  #category = null; // Category label

  // For use in wiggle animation
  #minMove = 5;
  #maxMove = 10;
  #wiggleDuration = 2000; // milliseconds per wiggle
  #startTime = null; // For calculating wiggle animation progress
  #currentX = 0; // Start position for wiggle animation
  #currentY = 0;
  #targetX = 0; // Target position for wiggle animation
  #targetY = 0;  
  #lerpedX = null; // Lerped X position for wiggle animation
  #lerpedY = null;

  #randomOffsetX = 0; // Random offset for tile position
  #randomOffsetY = 0; // Random offset for tile position

  static #mobileFocusedTile = null; // Track the tapped tile on touch devices

  // Constructor of tile instance
  constructor(idx, title, imgUrl, x = 0, y = 0, color, pathData, stage, fadeDelay = 0, permalink, category = null) {
    const randomOffset = 40; // Random offset for tile position
    const tileSize = 300; // Size of the tile, used to calculate random offset range

    this.#idx = idx;
    this.#color = color;
    this.#imgUrl = imgUrl;

    this.#randomOffsetX = Math.random() * randomOffset * (Math.random() < 0.5 ? -1 : 1);
    this.#randomOffsetY = Math.random() * randomOffset * (Math.random() < 0.5 ? -1 : 1);
    this.#offsetX = parseInt(x + this.#randomOffsetX); // Offset X position from center of stage
    this.#offsetY = parseInt(y + this.#randomOffsetY); // Offset Y position from center of stage

    this.#img.src = this.#imgUrl;
    this.#pathData = pathData;
    this.#fadeDelay = fadeDelay;
    this.#permalink = permalink;
    this.#category = category;

    this.#loadPromise = new Promise((resolve, reject) => {
      // Create the tile element
      this.#elm = document.createElement('div');
      this.#elm.className = 'iprt-html-tile';
      this.#elm.id = this.#idx;
      this.#elm.setAttribute('data-idx', idx);

      // Create the link element
      const link = document.createElement('div');
      link.className = 'tile-hover';
      link.href = this.#permalink;
      
      // Create the wrapper for image and svg for wiggle animation
      const wiggleDiv = document.createElement('div');
      wiggleDiv.className = 'wiggle';
      
      // Create the SVG element (shape)
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('width', tileSize);
      svg.setAttribute('height', tileSize);
      svg.setAttribute('viewBox', `0 0 ${tileSize} ${tileSize}`);
      svg.setAttribute('fill', 'none');
      
      // Create the path element for the shape
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', this.#pathData);
      path.setAttribute('fill', this.#color);
      // Append the shape path to the SVG element      
      svg.appendChild(path);
      // Append the SVG to the wrapper
      wiggleDiv.appendChild(svg);
      
      const imgDiv = document.createElement('div');
      imgDiv.style.width = '100%';
      imgDiv.style.height = '100%';
      // imgDiv.style.backgroundColor = 'red';
      imgDiv.style.clipPath = `path('${this.#pathData}')`;

      // Create the thumbnail image element
      const img = document.createElement('img');
      img.src = this.#imgUrl;
      img.alt = 'Image';
      // img.style.clipPath = `path('${this.#pathData}')`;
      // Append the image to the wrapper
      imgDiv.appendChild(img);
      wiggleDiv.appendChild(imgDiv);

      // Tile hover info container
      const hoverInfoDiv = document.createElement('div');
      hoverInfoDiv.className = 'tile-hover-info';
      wiggleDiv.appendChild(hoverInfoDiv);
      
      // Title label
      const titleDiv = document.createElement('div');
      titleDiv.className = 'tile-title';
      titleDiv.textContent = title;

      hoverInfoDiv.appendChild(titleDiv);

      // Category label: only create if a non-empty category is set
      if (typeof this.#category === 'string' && this.#category.trim() !== "") {
        const categoryDiv = document.createElement('div');
        categoryDiv.className = 'tile-category';
        categoryDiv.textContent = this.#category;
        categoryDiv.style.backgroundColor = this.#color;
        categoryDiv.style.borderColor = this.#color;
        hoverInfoDiv.appendChild(categoryDiv);
      }

      // Append the wrapper to the link element
      link.appendChild(wiggleDiv);
      // Append the link to the tile element
      this.#elm.appendChild(link);
      
      // Set the tile element's position
      this.#elm.style.top = this.#offsetY + 'px';
      this.#elm.style.left = this.#offsetX + 'px';

      // For testing  purposes, add an ID label to the tile element
      // const idLabel = document.createElement('div');
      // idLabel.className = 'absolute top-0 left-0 transform -translate-x-full -translate-y-full';
      // idLabel.textContent = this.#idx;
      // this.#elm.appendChild(idLabel);
      
      // Append the tile element to the stage
      stage.appendChild(this.#elm);

      this.#wiggleDiv = wiggleDiv;
      // this.#elm.style.pointerEvents = 'none'; // For testing purposes

      // Event listener for when the thumbnail image is loaded
      img.onload = () => {
        resolve(img);

        // Clean up event listeners
        img.onload = null;
        img.onerror = null;
      };

      img.onerror = () => {
        console.error(
          `Could not load the image: ${this.#imgUrl} (id: ${this.#idx})`
        );

        img.src = "/themes/custom/tema/src/assets/inspiratiepunten/tile-placeholder.jpg";

        img.onload = () => {
          resolve(img);
          img.onload = null;
          img.onerror = null;
        };

        // reject(new Error(`Failed to load image: ${this.#imgUrl}`));
      };
    });

    // On mouseenter pause tile wiggle animation
    this.#elm.addEventListener('mouseenter', (e) => {
      this.pauseWiggle();
      // cancelAnimationFrame(this.#reqAnimId);
      // this.#startTime = null;
    });

    // On mouseleave resume tile wiggle animation
    this.#elm.addEventListener('mouseleave', (e) => {
      this.resumeWiggle();
      // this.#newTarget(true);
    });


    function loadProjectPage(permalink) {
      document.getElementById('iprt-page-transition').style.display = 'block';
      document.getElementById('iprt-page-transition').style.pointerEvents = 'auto';
      setTimeout(() => {
        document.getElementById('iprt-page-transition').classList.add('active');

        setTimeout(() => {
          window.open(permalink, '_self');
          // document.getElementById('iprt-page-transition').style.pointerEvents = 'none';
          // document.getElementById('iprt-page-transition').classList.remove('active');
        }, 1500);;
      }, 1);
    }

    this.#elm.addEventListener('click', (e) => {
      e.preventDefault();

      const isMobile = navigator.maxTouchPoints > 0 || ('ontouchstart' in window);

      if (isMobile) {
        console.log('Mobile tile clicked:', this.#idx);

        if (this.#elm.classList.contains('drag-started-on') || this.#elm.classList.contains('is-tapped')) {
          console.log('LAUNCH!');
          loadProjectPage(this.#permalink);
          return;
        }

        document.querySelectorAll('.drag-started-on').forEach(tile => tile.classList.remove('drag-started-on'));
        document.querySelectorAll('.is-tapped').forEach(tile => tile.classList.remove('is-tapped'));
        this.#elm.classList.add('is-tapped');

        console.log('First tap, showing hover state');

        return;
      }

      console.log('Desktop tile clicked:', this.#idx);
      console.log('LAUNCH!');
      loadProjectPage(this.#permalink);
    });
  }

  // Get new target position for wiggle animation
  #getRandomOffset () {
    const r = () =>
      (Math.random() < 0.5 ? -1 : 1) *
      (this.#minMove + Math.random() * (this.#maxMove - this.#minMove));
    return [r(), r()];
  }

  // Set new target position for wiggle animation
  #newTarget(resume = false) {
    // If not from pause/resume, set current position as previous target position, else set current position as previous intermediate position
    this.#currentX = resume ? this.#lerpedX : this.#targetX;
    this.#currentY = resume ? this.#lerpedY : this.#targetY;
    [this.#targetX, this.#targetY] = this.#getRandomOffset(); // Get new random offset
    this.#startTime = null; // Reset start time = reset animation progress
    this.#reqAnimId = requestAnimationFrame(this.#wiggle);
  }

  #wiggle = (time) => {
    // If start time is null, set it to current time, a fresh wiggle cycle has started
    if (this.#startTime === null) this.#startTime = time;
    // Progress of current wigggle cycle
    const progress = (time - this.#startTime) / this.#wiggleDuration;

    // Calculate lerped values first
    this.#lerpedX = this.#currentX + (this.#targetX - this.#currentX) * Math.min(progress, 1);
    this.#lerpedY = this.#currentY + (this.#targetY - this.#currentY) * Math.min(progress, 1);

    // Wiggle cycle is finished
    if (progress >= 1) {
      // Apply final position
      this.#wiggleDiv.style.transform = `translate3d(${this.#targetX.toFixed(2)}px, ${this.#targetY.toFixed(2)}px, 0)`;
      // Start new wiggle cycle
      this.#newTarget();
      return;
    }

    // Apply current position
    this.#wiggleDiv.style.transform = `translate3d(${this.#lerpedX.toFixed(2)}px, ${this.#lerpedY.toFixed(2)}px, 0)`;

    this.#reqAnimId = requestAnimationFrame(this.#wiggle);
  }

  // Public method to access the load promise
  load() {
    return this.#loadPromise;
  }

  // Called when all tiles are loaded
  init() {
    // Fade in the tile element with delay
    setTimeout(() => {
      this.#elm.style.opacity = '1';
    }, this.#fadeDelay);

    // Start the wiggle animation
    [this.#targetX, this.#targetY] = this.#getRandomOffset();
    this.#reqAnimId = requestAnimationFrame(this.#wiggle);
  }

  getElement(idx) {
    return this.#elm;
  }

  pauseWiggle(idx = null) {
    // console.log('pauseWiggle', idx == null ? this.#idx : idx);
    cancelAnimationFrame(this.#reqAnimId);
    // console.log('this.#reqAnimId', this.#reqAnimId);
    this.#reqAnimId = null;
    this.#startTime = null;
  }

  resumeWiggle(idx = null) {
    // console.log('resumeWiggle', idx == null ? this.#idx : idx);
    if (this.#reqAnimId) return;
    this.#newTarget(true);
  }

  remove() {
    // Remove animation frame if running
    if (this.#reqAnimId) {
      cancelAnimationFrame(this.#reqAnimId);
      this.#reqAnimId = null;
    }

    // Clean up DOM
    if (this.#elm && this.#elm.parentNode) {
      this.#elm.parentNode.removeChild(this.#elm);
      this.#elm = null;
    }
  }

  // Update tile position when window is resized
  updateXY(x, y) {
    this.#offsetX = parseInt(x + this.#randomOffsetX);
    this.#offsetY = parseInt(y + this.#randomOffsetY);

    if (this.#elm) {
      this.#elm.style.left = `${this.#offsetX}px`;
      this.#elm.style.top = `${this.#offsetY}px`;
    }
  }
}